import { Box } from '@mui/material';

const Back = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '80px',
        background: '#0000001A',
        position: 'absolute',
      }}
    />
  );
};

export default Back;
